import { array } from 'prop-types';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';
import { ABOUT_US, CATEGORY } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';


export const getCategoryList = async (data = array()) => {
    try {
        let url = data?._Id ? `${CATEGORY.GET_CATEGORY_LIST}/${data?._Id}` : `${CATEGORY.GET_CATEGORY_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const addCategory = async (data = array()) => {
    try {
        const response = await POST(CATEGORY.ADD_CATEGORY, data);
        return response;
    } catch (error) {
        toast.error(response.message);
    }
};

export const updateCategory = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${CATEGORY.EDIT_CATEGORY}/${id}`;
        const response = await POST(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
    }
};

export const getJobCategoryList = async (data = array()) => {
    try {
        let url = data?._Id ? `${CATEGORY.GET_CATEGORY_LIST}/${data?._Id}` : `${CATEGORY.GET_CATEGORY_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const addJobCategory = async (data = array()) => {
    try {
        const response = await POST(CATEGORY.GET_CATEGORY_LIST, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const updateJobCategory = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${CATEGORY.GET_CATEGORY_LIST}/${id}`;
        const response = await PUT(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getJobCategoryDataById = async (data = array()) => {
    try {
        let url = data?.Id ? `${CATEGORY.GET_CATEGORY_LIST}/${data?.Id}` : `${CATEGORY.GET_CATEGORY_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

// export const fetchJobCategoryTableAndFilterSchema = async (data = array()) => {
//     try {
//         const response = await GET(CATEGORY.GET_JOB_CATEGORY_SCHEMA);
//         return response;
//     } catch (error) {
//         toast.error(error.message);
//     }
// };

export const fetchJobCategoryTableAndFilterSchema = async (data = array()) => {
    try {
        let url = data?._Id ? `${CATEGORY.GET_JOB_CATEGORY_SCHEMA}/${data?._Id}` : `${CATEGORY.GET_JOB_CATEGORY_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const submitFilterData = async (data = array()) => {
    try {
        const response = await POST(CATEGORY.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const getRegisterFieldDataUsingJobCategoryId = async (data = array()) => {
    try {
        const response = await GET(`${data?.jobCategoryId ? `${CATEGORY.REGISTER_FIELD}/${data?.jobCategoryId}` : CATEGORY.REGISTER_FIELD}`, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const submitAllRegisterFieldData = async (data = array()) => {
    try {
        const response = await POST(CATEGORY.SUBMIT_REGISTER_FIELD, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

